const TEMP_PLAYLIST = [
  {
    url: 'https://Zipp-radio-vol1.b-cdn.net/Zipp-radio-vol1/RETAIL-.-.mp3',
    title: 'RETAIL'
  }
];

function getTempShuffledPlaylist() {
  return {
    urls: TEMP_PLAYLIST.map(track => track.url),
    originalIndices: [0]
  };
}

window.TEMP_PLAYLIST = TEMP_PLAYLIST;
window.getTempShuffledPlaylist = getTempShuffledPlaylist;

